import React from 'react';
import { useEditSceneModalStateContext } from '../state';
import { block } from '../utils';
import EditSceneCaptionsLayer from './EditSceneCaptionsLayer';
import { EditScenePreviewLoadingOverlay } from './EditScenePreviewLoadingOverlay';
import EditSceneSlots from './EditSceneSlots';
import EditSceneSlotsOverlay from './EditSceneSlotsOverlay';

export type EditScenePreviewProps = {};

const EditScenePreview: React.FC<EditScenePreviewProps> = () => {
  const {
    state: { previewDimensions },
  } = useEditSceneModalStateContext();

  return !previewDimensions ? null : (
    <div className={block('preview')}>
      <EditSceneSlots />
      <EditSceneSlotsOverlay />
      <EditSceneCaptionsLayer />
      <EditScenePreviewLoadingOverlay />
    </div>
  );
};

export default EditScenePreview;
